<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useApprovals} from "@/composables/approval-center/useApprovals";

const props = defineProps({
  category: {
    required: true,
    type: String,
  },
  perPage: {
    required: false,
    type: Number,
    default: 3,
  },
});

const {
  hasNextPage,
  isFetchingNextPage,
  handleLoadMore,
} = useApprovals(props.category, props.perPage);
</script>

<template>
  <div
    v-if="hasNextPage"
    class="tw-flex tw-justify-center tw-mt-10"
  >
    <DefaultButton
      variant="primary-inverted"
      :loading="isFetchingNextPage"
      :disabled="isFetchingNextPage"
      @click="handleLoadMore"
    >
      View More
    </DefaultButton>
  </div>
</template>
